import { render, staticRenderFns } from "./ListDeliveryDate.vue?vue&type=template&id=6f12c994"
import script from "./ListDeliveryDate.vue?vue&type=script&lang=js"
export * from "./ListDeliveryDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ListDeliveryDate.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f12c994')) {
      api.createRecord('6f12c994', component.options)
    } else {
      api.reload('6f12c994', component.options)
    }
    module.hot.accept("./ListDeliveryDate.vue?vue&type=template&id=6f12c994", function () {
      api.rerender('6f12c994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ListDeliveryDate.vue"
export default component.exports